import { apiFetch } from "@/lib/api-client";

export function isPdfManual(fileName: string, mime?: string | null): boolean {
  const m = (mime || "").toLowerCase();
  if (m.includes("pdf")) return true;
  return /\.pdf$/i.test(fileName);
}

export async function downloadManualFile(
  manualId: string,
  fileName: string,
  fileMime?: string | null,
): Promise<void> {
  try {
    const res = await apiFetch(`/api/manuals/${manualId}/file?download=1`, { credentials: "include" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const type = blob.type || (fileMime || undefined) || "application/octet-stream";
    const file = new File([blob], fileName, { type });

    if (typeof navigator !== "undefined" && typeof navigator.share === "function" && typeof navigator.canShare === "function") {
      try {
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: fileName });
          return;
        }
      } catch (e: unknown) {
        const name = e && typeof e === "object" && "name" in e ? String((e as { name: string }).name) : "";
        if (name === "AbortError") return;
      }
    }

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 100);
  } catch (err) {
    console.error("[Manuals] Download failed:", err);
  }
}
